export const siteTitle = 'Engineering Unblocked'
export const siteUrl = 'https://www.swarmia.com'
export const siteEmail = 'rmurphey@swarmia.com'

export const applePodcastsUrl =
  'https://podcasts.apple.com/us/podcast/engineering-unblocked/id1690770396'
export const spotifyUrl = 'https://open.spotify.com/show/0n4EjxynhHXcxhJCqVcfV4'
export const castboxUrl = 'https://castbox.fm/channel/id5461581'
export const pocketCastsUrl = 'https://pca.st/z2nt1i0x'
export const stitcherUrl = 'https://www.stitcher.com/show/1071537'
export const rssUrl = 'https://anchor.fm/s/e1450394/podcast/rss'
export const googlePodcastsUrl =
  'https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy9lMTQ1MDM5NC9wb2RjYXN0L3Jzcw'
